// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__T7Qs2","row":"Footer_row__hnkJJ"};